/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Table,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { callAPI } from 'lorautils/api';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import SearchInput from 'loracoms/SearchInput';
import TablePager from 'loracoms/TablePager';
import Checkbox from 'loracoms/Checkbox';
import ShowIf from 'loracoms/ShowIf';
import dashboardActions from 'loraactions/dashboard';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  checked: PropTypes.array.isRequired,
};

const defaultProps = {
  checked: [],
};

class DeviceModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checked: props.checked,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.mark = '';
    this.q = null;
  }

  componentWillMount() {
    const checked = JSON.parse(sessionStorage.getItem('device'));
    if (checked) {
      this.setState({ checked });
    }
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
      if (showModal) {
        this.loadData();
      }
    }
  }

  componentWillUnmount() {
    this.loadData = null;
  }

  loadData() {
    callAPI({
      endpoint: '/lora/nodes',
      query: {
        q: this.q,
        mark: this.mark,
        limit: 10,
      },
    }).then((data) => {
      const { list, more, mark } = data;
      this.setState({
        lists: list,
        status: 'success',
        more,
        mark,
        noData: list.length === 0,
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  isChecked(d) {
    const { checked } = this.state;
    return _.some(checked, { id: d.id });
  }

  toggleCheck(d) {
    let { checked } = this.state;
    if (this.isChecked(d)) {
      checked = _.filter(checked, c => c.id !== d.id);
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked });
  }

  handleSearch(e) {
    const search = e.target.value;
    this.setState({
      search,
      reset: new Date(),
    });
    this.mark = '';

    if (search.length > 0) {
      const s = search.replace(/[:-]/g, '');
      this.q = `or,name:*${s}*,deveui:*${s}*,devaddr:*${s}*,appIdeui:${s}*,city:*${s}*,area:*${s}*,band:*${s}*`;
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  }

  handleSubmit() {
    const { onHide, onSelect } = this.props;
    const { checked } = this.state;
    onHide();
    onSelect(checked);

    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() });
  }

  handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  }

  handleCancel() {
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date(), checked: [] });
    this.props.onHide();
  }

  render() {
    const {
      showModal,
      search = '',
      mark = '',
      more = false,
      reset,
      status,
      lists,
      noData = false,
    } = this.state;
    const rows = _.map(lists, item => (
      <tr key={item.id}>
        <td>
          <div className={styles.checkbox}>
            <Checkbox
              id={item.id}
              checked={this.isChecked(item)}
              onChange={() => this.toggleCheck(item)}
            />
            <label htmlFor={item.id} />
          </div>
        </td>
        <td>{item.name}</td>
        <td>{normalizeDevEUI(item.deveui)}</td>
        <td>{format(item.createdAt, 'YYYY-MM-DD HH:mm:ss')}</td>
      </tr>
    ));
    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-light"
        onHide={this.handleCancel}
      >
        <Modal.Header closeButton>
          <SearchInput
            onChange={this.handleSearch}
            value={search}
            placeholder={this.intlMsg.msg('search.placeholder')}
          />
        </Modal.Header>
        <Modal.Body className="clearfix" styleName="modalbody">
          <Table
            className="aisz-table-light" striped hover bordered responsive
          >
            <thead>
              <tr>
                <th />
                <th>{this.intlMsg.msg('addmodal.name')}</th>
                <th>{this.intlMsg.msg('addmodal.deveui')}</th>
                <th>{this.intlMsg.msg('addmodal.createdAt')}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <ShowIf if={noData}>
            <div className="text-center">
              {this.intlMsg.msg('adddevice.nodata')}
            </div>
          </ShowIf>
          <div className="pull-right">
            <TablePager
              status={status}
              mark={mark}
              more={more}
              onPrev={this.handleChangeMark}
              onNext={this.handleChangeMark}
              reset={reset}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.handleSubmit()}
          >
            {this.intlMsg.msg('confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            onClick={this.handleCancel}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DeviceModal.propTypes = propTypes;
DeviceModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  getDeveui: dashboardActions.getDeveui,
};

export default connect(null,
  mapDispatchToProps,
)(injectIntl(CSSModules(DeviceModal,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/DeviceModal/index.jsx